import { AutogenModelEquipMatchDetail, AutogenRowEquipMatchDetail } from "./autogen/AutogenModelEquipMatchDetail";

export class ModelEquipMatchDetail extends AutogenModelEquipMatchDetail<RowEquipMatchDetail> {
    constructor() {
        super(RowEquipMatchDetail);
    }
}

export class RowEquipMatchDetail extends AutogenRowEquipMatchDetail {
}